module.exports = __webpack_public_path__ + "8cf4e4ccb8b3d609a68e7bfc766ab5a6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/phyto/bpeel-alt-b.png
 ** module id = 479
 ** module chunks = 0
 **/